import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import getThemeContent from './themes';
import { copyText, showFallbackMessage } from './copy';
export default function injectButtons(rootEl, theme) {
  const _getThemeContent = getThemeContent(theme),
    _getThemeContent2 = _slicedToArray(_getThemeContent, 3),
    idle = _getThemeContent2[0],
    okHtml = _getThemeContent2[1],
    errHtml = _getThemeContent2[2];
  rootEl.querySelectorAll('pre').forEach(pre => {
    if (pre.classList.contains('copy-ready')) return;
    const btn = document.createElement('button');
    btn.className = "clipboard ".concat(theme);
    btn.type = 'button';
    btn.innerHTML = idle;
    btn.setAttribute('aria-label', extractText(app.translator.trans('linkrobins-clipboard.forum.copy_code_aria')));
    if (theme === 'lingcoder' || theme === 'csdn') {
      pre.classList.add('sticky');
    }
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const code = pre.querySelector('code');
      const text = (code ? code.innerText : pre.innerText).replace(/^\s+/, '').replace(/\s+$/, '');
      copyText(text).then(() => {
        btn.classList.add('succeed');
        if (okHtml) btn.innerHTML = okHtml;
        setTimeout(() => {
          btn.classList.remove('succeed');
          btn.innerHTML = idle;
        }, 1000);
      }).catch(() => {
        btn.classList.add('failed');
        if (errHtml) btn.innerHTML = errHtml;
        setTimeout(() => {
          btn.classList.remove('failed');
          btn.innerHTML = idle;
        }, 1500);
        showFallbackMessage();
      });
    });
    pre.insertBefore(btn, pre.firstChild);
    pre.classList.add('copy-ready');
  });
}